import { Component, EventEmitter, OnInit, Output,Injectable ,OnDestroy} from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute,NavigationEnd } from '@angular/router';
import { CommonService } from '../Services/common.service';
import { TranactionService } from '../Services/Transaction/transaction.service';
import { CheckoutService } from 'paytm-blink-checkout-angular';
import { Subscription } from 'rxjs';
import { Guid } from 'guid-typescript';
import { HttpClient, HttpHeaders, HttpParams} from "@angular/common/http";
import { Observable } from 'rxjs';
@Component({
  selector: 'app-chits',
  templateUrl: './chits.component.html',
  styleUrls: ['./chits.component.css']
})
@Injectable()
export class ChitsComponent implements OnDestroy {
  private subs: Subscription;
  myaccount: FormGroup;
  //openInPopup = true;
  istransVisible = false;
  isshowconfirmation= false;
  isCheckoutVisible = false;
  lsSubSubscriberChitDetails: any=[];
  count: any;
  SubSubscriberChitInfo: any=[];
  recenttransInfo: any=[];
  chitInfoInCards: boolean=true;
  chittab: boolean=true;
  auctioncount:any;
  usermobileNo: string;
  selected = [];
  public id: Guid;
  totaldue: number;
  totalpaying: number;
  rows: any =[];
  isshowmyacc:boolean=true; 
  txnorderid:any;
  txntoken:any;
  txamount:any;
  numamount: string;
  serverdate: string;
  vchbankname: string;
  vchtransidid: string;
  vchbanktransid: string;
  vchtrans: string;
  vchfailreasons: string;
  orderid: string;
  verifystatus: string;
  pmid: any;
  logo: any;
  cname: any;
  constructor(private _commonservice: CommonService,private _tranactionService: TranactionService, private fb: FormBuilder,private readonly checkoutService: CheckoutService, private http: HttpClient,private dataRoute: ActivatedRoute, private router: Router) { 
    this.usermobileNo =sessionStorage.getItem('currentUser');
  }

  ngOnInit() {

    // alert(sessionStorage.getItem("orderid"));
//     if(sessionStorage.getItem("orderid")==null || sessionStorage.getItem("orderid")==undefined)
//     {
//       this.istransVisible=false;
//       this.isshowconfirmation=false;
//     }  
//     else
//     {

      
// let orderid=sessionStorage.getItem("orderid");
// this._tranactionService._getorderdetails(orderid).subscribe(result => {
//   debugger;
//   if(result!=null)
//   {
//    this.numamount=result['txtamount'];
//    this.serverdate=result['transdate'];
//    this.vchbankname=result['bankname'];
//    this.vchtransidid=result['txtid'];
//    this.vchbanktransid=result['banktransid'];
//    this.verifystatus=result['vchstatus'];
//    this.vchfailreasons=result['txtfailurereason'];
//    this.orderid=result['orderid'];
//   //  alert(this.vchtransidid);
//   //  alert(this.vchbanktransid);
//    if(this.vchtransidid=='null' && this.vchbanktransid=='null')
//    {
//     this.istransVisible=false;
//     this.isshowconfirmation=false;
//     this.isshowmyacc=true; 

//    }  
//    else
//    {
//     this.istransVisible=true;
//     this.isshowmyacc=false; 
//     this.isshowconfirmation=false;
//    }
//   }
// });
//     }

//      sessionStorage.removeItem("orderid");
    this.myaccount=this.fb.group({
      recordid :[''],
      vchmerchantid:[''],
      numamount :[''],
      vchprn :[''],
      vchcrn :[''],
      vchitc:[''],
      numbankcode :[''],
     customerbankaccno :[''],
     vchprdcode1 :[''],
        vchprdcode2 :[''],
        vchprdcode3 :[''],
       vchprdcode4 :[''],
        vchcustname :[''],
       vchaddress1 :[''],
        vchaddress2 :[''],
        vchcity :[''],
        numpincode :[''],
       vchstate :[''],
        vchcountry :[''],
        vchemail:[''],
        numphone:[''],
        nummobile :[''],
        vchudf01 :[''],
        vchudf02 :[''],
        vchudf03 :[''],
        vchbankname :[''],
        vchtransidid:[''],
        vchbanktransid :[''],
        vchtransstatus :[''],
        vchfailreasons :[''],
        vchcustid :[''],
        transactiontype:[''],
        loginid :[''],
        logindate :[''],
        serverdate :[''],
        clientipaddress :[''],
        clientlocation :[''],
        paymentmode:[''],
        vchprdcode5 :[''],
        vchprdcode6 :[''],
        vchmerchandtxnid :[''],
        vchbranchstatus :[''],
        vchprdcode7 :[''],
        vchprdcode8 :[''],
        vchprdcode9 :[''],
        vchprdcode10 :[''],
        vchgateway:[''],
       lsttransdetailsdto: this.fb.array([]),
     })
    this.GetSubscriberChitDetails()  
  }
  addchitdetailsControls(): FormGroup {
    return this.fb.group({
      recordid : [''],
      details_id : [''],
    vchsubscribername : [''],
    chitno: [''],
      vchcustid : [''],
      vchcustname : [''],
      vchbranchname : [''],
     vchtrtycode : [''],
   vchtrtyname : [''],
    vchtransstatus : [''],
      vchfailurereasons: [''],
      numdueamount: [''],
     numpaidamount : [''],
      numdiffamount: [''],
   logindate : [''],
     vchprn : [''],
     vchschemacode : ['']
    })
  }
  movetopaymentpage()
  {
    debugger;
    let count=0;
    let checkboxvalueouter='false';
    let moveforword=false;
    this.totaldue = 0;
    this.totalpaying = 0;

    for (let i = 0; i < this.lsSubSubscriberChitDetails.length; i++) {
      var checkboxvalue = document.getElementById("item_"+i);
     let checkvalue= checkboxvalue.getAttribute('value');
if(this.lsSubSubscriberChitDetails[i].payamount!='' && checkvalue=='true')
{
  // this.totaldue = this.totaldue + parseInt(this.chitdetails[i].pnetpayable);
  // this.totalpaying = this.totalpaying + parseInt(this.chitdetails[i].payamount);
  // this.rows.push(this.chitdetails[i]);
  count=1;
  checkboxvalueouter='true';
  moveforword=true;
}
if(this.lsSubSubscriberChitDetails[i].payamount=='' && checkvalue=='true')
{
  count=1;
  checkboxvalueouter='true';
  document.getElementById('text_'+i).style.border ="1px solid red";
  moveforword=false;

}

    }
     
if(count==0 && checkboxvalueouter=='false')
{

alert("please select atleast one chit proceed to payment");
}
if(moveforword==true)
{

  for (let i = 0; i < this.lsSubSubscriberChitDetails.length; i++) {

    var checkboxvalue = document.getElementById("item_"+i);
    let checkvalue= checkboxvalue.getAttribute('value');
if(this.lsSubSubscriberChitDetails[i].payamount!='' && checkvalue=='true')
{
 
    this.totaldue = this.totaldue + parseInt(this.lsSubSubscriberChitDetails[i].ptotaldue);
    this.totalpaying = this.totalpaying + parseInt(this.lsSubSubscriberChitDetails[i].payamount);
    this.rows.push(this.lsSubSubscriberChitDetails[i]);
}
  
  }
  this.isshowmyacc=false;
  this.isshowconfirmation=true;
}
  }

  Continue()
  {
    this.istransVisible=false;
    this.isshowconfirmation=false; 
    sessionStorage.removeItem("orderid");
    this.isshowmyacc=true;
  }
  change(index,event)
  {
  for (let i = 0; i < this.lsSubSubscriberChitDetails.length; i++) {
    if (index == i) {
    this.lsSubSubscriberChitDetails[i].payamount = event.target.value;
    
    if(this.lsSubSubscriberChitDetails[i].payamount!='')
    {
      document.getElementById('text_'+i).style.border ="1px solid green";
    }
    if(this.lsSubSubscriberChitDetails[i].payamount=='')
    {
      document.getElementById('text_'+i).style.border ="1px solid red";
    }

    }
  }

  }
  changechitno(index,event)
  {
    if(event.target.checked){

 var eleman = document.getElementById("text_"+index);
                       eleman.removeAttribute("disabled");
                       var checkboxvalue = document.getElementById("item_"+index);                  
                       checkboxvalue.setAttribute("value","true");

    }
    else
    {
      var eleman = document.getElementById("text_"+index);
      eleman.innerHTML ="";
      eleman.setAttribute("disabled","true");
      var checkboxvalue = document.getElementById("item_"+index);                  
      checkboxvalue.setAttribute("value","false");
for (let i = 0; i < this.lsSubSubscriberChitDetails.length; i++) {
    if (index == i) {
    this.lsSubSubscriberChitDetails[i].payamount = '';
    }
    }  
  }
   
  }
  onlyNumberKey(event) {
    if (event.target.value.length == 0 && event.which == 48) {
      return false;
       }
       else
       {
    return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57;
       }
}
   isNumberKey(evt)
       {
          var charCode = (evt.which) ? evt.which : evt.keyCode;
          if (charCode != 46 && charCode > 31 
            && (charCode < 48 || charCode > 57))
             return false;

          return true;
       }
       Back()
       {
        this.isshowconfirmation=false;  
         this.isshowmyacc=true; 
         this.rows=[];
         for (let i = 0; i < this.lsSubSubscriberChitDetails.length; i++) {
           this.lsSubSubscriberChitDetails[i].payamount = '';
           }   
       }
Confirm():void
{
debugger;
  this.id = Guid.create();
  this.myaccount.controls.vchmerchantid.setValue('RaoBro79586331711006');
  this.myaccount.controls.numamount.setValue(this.totalpaying);
  this.myaccount.controls.vchprn.setValue(this.id['value']);
  this.myaccount.controls.vchcrn.setValue('');
  this.myaccount.controls.vchitc.setValue('');
  this.myaccount.controls.numbankcode.setValue('');
  this.myaccount.controls.customerbankaccno.setValue('');
  this.myaccount.controls.vchprdcode1.setValue('');
  this.myaccount.controls.vchprdcode2.setValue('');
  this.myaccount.controls.vchprdcode3.setValue('');
  this.myaccount.controls.vchprdcode4.setValue('');
  this.myaccount.controls.vchcustname.setValue(this.rows[0].psubscribername);
  this.myaccount.controls.vchaddress1.setValue('');
  this.myaccount.controls.vchaddress2.setValue('');
  this.myaccount.controls.vchcity.setValue('');
  this.myaccount.controls.numpincode.setValue('');
  this.myaccount.controls.vchstate.setValue('');
  this.myaccount.controls.vchcountry.setValue('');
  this.myaccount.controls.vchemail.setValue('');
  this.myaccount.controls.numphone.setValue(sessionStorage.getItem("currentUser"));
  this.myaccount.controls.nummobile.setValue(sessionStorage.getItem("currentUser"));
  this.myaccount.controls.vchudf01.setValue('');
  this.myaccount.controls.vchudf02.setValue('');
  this.myaccount.controls.vchudf03.setValue('');
  this.myaccount.controls.vchbankname.setValue('');
  this.myaccount.controls.vchtransidid.setValue('');
  this.myaccount.controls.vchbanktransid.setValue('');
  this.myaccount.controls.vchtransstatus.setValue('');
  this.myaccount.controls.vchfailreasons.setValue('');
  this.myaccount.controls.vchcustid.setValue('');
  this.myaccount.controls.transactiontype.setValue('');
  this.myaccount.controls.loginid.setValue('');
  this.myaccount.controls.logindate.setValue('');
  this.myaccount.controls.serverdate.setValue('');
  this.myaccount.controls.clientipaddress.setValue('');
  for (let i = 0; i < this.rows.length; i++) {
    const chitdetailscontrol = <FormArray>this.myaccount['controls']['lsttransdetailsdto'];
    chitdetailscontrol.push(this.addchitdetailsControls());
    this.myaccount['controls']['lsttransdetailsdto']['controls'][i]['controls']['vchsubscribername'].setValue(this.rows[i].psubscribername);
    this.myaccount['controls']['lsttransdetailsdto']['controls'][i]['controls']['chitno'].setValue(this.rows[i].pchitno);
    this.myaccount['controls']['lsttransdetailsdto']['controls'][i]['controls']['vchcustid'].setValue('kc001');
    this.myaccount['controls']['lsttransdetailsdto']['controls'][i]['controls']['vchcustname'].setValue(this.rows[i].psubscribername);
    this.myaccount['controls']['lsttransdetailsdto']['controls'][i]['controls']['vchbranchname'].setValue(this.rows[i].pvchbranch);
    this.myaccount['controls']['lsttransdetailsdto']['controls'][i]['controls']['vchtrtycode'].setValue(this.rows[i].pvchterritory);
    this.myaccount['controls']['lsttransdetailsdto']['controls'][i]['controls']['vchtrtyname'].setValue(this.rows[i].pvchterritory);
    this.myaccount['controls']['lsttransdetailsdto']['controls'][i]['controls']['numdueamount'].setValue(this.rows[i].pdue);
    this.myaccount['controls']['lsttransdetailsdto']['controls'][i]['controls']['numpaidamount'].setValue(this.rows[i].payamount);
    this.myaccount['controls']['lsttransdetailsdto']['controls'][i]['controls']['vchprn'].setValue(this.id['value']);  
    this.myaccount['controls']['lsttransdetailsdto']['controls'][i]['controls']['vchschemacode'].setValue('khk01');  
    this.myaccount['controls']['lsttransdetailsdto']['controls'][i]['controls']['logindate'].setValue('16-08-2021');  

  }
  let data = JSON.stringify(this.myaccount.value);
const chitdtetailsdtocontrol = <FormArray>this.myaccount.controls['lsttransdetailsdto'];
for (let i = chitdtetailsdtocontrol.length - 1; i >= 0; i--) {
  chitdtetailsdtocontrol.removeAt(i)
}


debugger;
  this._tranactionService._savetransdetails(data).subscribe(result => {
    if(result!=null)
    {
var oid=result['porderid'];
var otoken=result['ptoken'];
var oamount=result['pamount'];
var mid=result['pmid'];
var logo=result['plogo'];
var companyname=result['pcompanyname'];
this.txnorderid=oid;
this.txntoken=otoken;
this.txamount=oamount;
this.cname=companyname;
this.logo=logo;
this.pmid=mid;
sessionStorage.setItem('orderid',this.txnorderid);
this.checkoutService.init(
  //config
  {
    data: {
      orderId: this.txnorderid,
      amount: this.txamount,
      token: this.txntoken,
      tokenType: "TXN_TOKEN"
    },
    merchant: {
      mid:this.pmid, //"RaoBro79586331711006",
      name:this.cname,// "Rao chits",
      redirect: true,
      logo:this.logo
      
    },
    flow: "DEFAULT",
    handler: {
      notifyMerchant: this.notifyMerchantHandler
    }
  },
  //options
  {
    env: 'STAGE', // optional, possible values : STAGE, PROD; default : PROD
    openInPopup: true // optional; default : true
  }
);

this.subs = this.checkoutService
  .checkoutJsInstance$
  .subscribe(instance=>console.log(instance));
}

      
  }); 

}




notifyMerchantHandler = (eventType, data): void => {


  console.log('MERCHANT NOTIFY LOG', eventType, data);
}

ngOnDestroy(): void {
  if (this.subs) {


 
    this.subs.unsubscribe();
  }
}
  GetSubscriberChitDetails() {
    this._tranactionService.GetSubscriberChitDetails(this.usermobileNo).subscribe(json => {
      if (json != null) {
        this.lsSubSubscriberChitDetails = json
        this.count = this.lsSubSubscriberChitDetails.length;
      }
    },
      (error) => {
        this._commonservice.showErrorMessage(error);
      });
  }

  GetSubscriberChitDetailsbasedongroupcode(chitno) {
    this.SubSubscriberChitInfo=[];
    this.recenttransInfo=[];
    this._tranactionService.GetSubscriberChitDetailsbasedongroupcode(chitno).subscribe(json => {
      debugger;
      this.chitInfoInCards=false;
      if (json != null) {
        this.SubSubscriberChitInfo.push(json);
        this.recenttransInfo = json["lstSubscribertransDTO"];
      }
    },
      (error) => {
        this._commonservice.showErrorMessage(error);
      });
  }
  back(){
    this.SubSubscriberChitInfo=[];
    this.recenttransInfo=[];
    this.chitInfoInCards=true;
  }
  Chittab(name){
    if(name == 'C'){
      this.chittab = true;
      this.SubSubscriberChitInfo=[];
      this.recenttransInfo=[]; 
      this.chitInfoInCards=true;
    }else if (name == 'A'){
      this.chittab = false;
    }
  }
  auctionCount($event){
  this.auctioncount = $event;
  }
}
